import * as React from "react";

import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { Headings } from "@project-stories/elements/Headings/Headings";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import {mobileBreakpoint} from "@src/../entrypoints/theme";
import ImageComponent from "@project-stories/elements/Image/Image";

export const CollectionHeader = ({ settings }) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  if (settings.section_settings.collection_header_type == "image") {
    return (
      <div className="relative w-full h-full collection-header__with-image">
        {settings.section_settings.image && (
          <ImageComponent
            imageUrl={settings.section_settings.image}
            alt={settings.section_settings.image.alt || 'Tile image'}
            classes={`object-cover h-full w-full absolute inset-0 w-full h-full`}
            isLazy={false}
            useSrcSet={true}
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 75vw"
            priority={true}
          />
        )}
        <div
          className={`absolute top-0 left-0 w-full flex flex-col text-center h-full justify-${settings.section_settings.content_vertical_position_mobile} lg:justify-${settings.section_settings.content_vertical_position_desktop} pt-[${settings.section_settings.padding_top_mobile}px] 
          lg:pt-[${settings.section_settings.padding_top_desktop}px] 
          pb-[${settings.section_settings.padding_bottom_mobile}px] 
          lg:pb-[${settings.section_settings.padding_bottom_desktop}px] 
          px-[${settings.section_settings.padding_left_right_mobile}px] 
          lg:px-[${settings.section_settings.padding_left_right_desktop}px]`}
        >
          <div
            className={`mb-[${settings.section_settings.title_margin_bottom_mobile}px] lg:mb-[${settings.section_settings.title_margin_bottom_desktop}px]`}
          >
            {isMobile && (
              <Headings
                text={settings.section_settings.title}
                classes={`collection-header__with-image__title ${settings.section_settings.heading_type_mobile}`}
              />
            )}
            {!isMobile && (
              <Headings
                text={settings.section_settings.title}
                classes={`collection-header__with-image__title ${settings.section_settings.heading_type_desktop}`}
              />
            )}
          </div>

          {settings.section_settings.show_description && (
            <p
              dangerouslySetInnerHTML={{ __html: settings.description }}
              className={`rich-content ${settings.section_settings.body_type} self-center w-full lg:max-w-[${settings.section_settings.content_width}] max-h-full overflow-auto`}
            ></p>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`collection-header-without-image flex flex-col text-center h-full justify-${settings.section_settings.content_vertical_position_mobile} lg:justify-${settings.section_settings.content_vertical_position_desktop} pt-[${settings.section_settings.padding_top_mobile}px] lg:pt-[${settings.section_settings.padding_top_desktop}px] pb-[${settings.section_settings.padding_bottom_mobile}px] lg:pb-[${settings.section_settings.padding_bottom_desktop}px] px-[${settings.section_settings.padding_left_right_mobile}px] lg:px-[${settings.section_settings.padding_left_right_desktop}px]`}
      >
        {isMobile && (
          <Headings
            text={settings.section_settings.title}
            classes={`collection-header-without-image__title ${settings.section_settings.heading_type_mobile} mb-[${settings.section_settings.title_margin_bottom_mobile}px] lg:mb-[${settings.section_settings.title_margin_bottom_desktop}px]`}
          />
        )}
        {!isMobile && (
          <Headings
            text={settings.section_settings.title}
            classes={`collection-header-without-image__title ${settings.section_settings.heading_type_desktop} mb-[${settings.section_settings.title_margin_bottom_mobile}px] lg:mb-[${settings.section_settings.title_margin_bottom_desktop}px]`}
          />
        )}
        {settings.section_settings.show_description && (
          <Paragraph
            text={settings.description}
            type={`${settings.section_settings.body_type} self-center w-full lg:max-w-[${settings.section_settings.content_width}]`}
          />
        )}
      </div>
    );
  }
};

export default CollectionHeader;
